import { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { EyeIcon } from "../kits/Icons";
import Tabs from "../tab/Tabs.jsx";
import InfoTab from "./InfoTab.jsx";
import OrderList from "../order/OrderList.jsx";
import TransactionList from "../financial-management/TransactionList.tsx";
import MessageInfo from "../message/MessageInfo.jsx";
import Message from "../../pages/Message.jsx";

import CustomButton from "../kits/button/CustomButton.jsx";
import { CustomTooltip } from "../kits/tooltip/CustomTooltip.jsx";
import useAxios from "../../services/useAxios.tsx";

import { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";

export default function CustomerInfoModal({
  customerData,
  bankName,
  setCustomerUpdater
}) {
  const { execute: orderList } = useAxios("api2/orders_list");
  const [customerInfoShow, setCustomerInfoShow] = useState(false);
  const [customer, setCustomer] = useState({});
  const [nav, setNav] = useState([
    { title: "اطلاعات", target: "#navs-pills-left-info" },
    { title: "ارتباطات", target: "#navs-pills-left-connection" },
    { title: "لیست سفارشات", target: "#navs-pills-left-factors" },
    { title: "امور مالی", target: "#navs-pills-left-financial" }
  ]);
  const [tab, setTab] = useState([]);
  const [orders, setOrders] = useState([]);
  const [updater, setUpdater] = useState(false);
  const { execute: transactionList } = useAxios("api2/transactions_list");
  const [transact, setTransact] = useState([]);
  const getData = () => {
    // امور مالی
    transactionList({ customer_id: customerData.id }).then(data => {
      let resTran = data.transactions.map(t => {
        let date;
        if ("" + t.mtm !== "") {
          date = new DateObject({
            date: +t.mtm * 1000,
            calendar: persian,
            locale: persian_fa
          });
        }

        const isReceiver = +t.customer_id === +t.to_account.customer_id;

        return {
          id: t.bank_transaction__id,
          uid: t.customer_id,
          payDate: date ? date.format("YYYY/MM/DD") : "",
          payTime: date ? date.format("HH:mm") : "",
          payType: +t.type,
          bankName: isReceiver ? t.to_account.bank : t.from_account.bank,
          accountNumber: isReceiver
            ? t.to_account.account_number
            : t.from_account.account_number,
          status: +t.status
        };
      });
      setTransact(resTran);
      console.log("transact", transact);
      return resTran;
    });
    //  لیست سفارشات
    orderList({ customer_id: customerData.id }).then(data => {
      let temp = [];
      temp = data.orders.map(value => {
        return {
          ...value,
          order_items: value.order_items.map(val => {
            return {
              ...val,
              OptionOrderItem: JSON.parse(val.OptionOrderItem)
            };
          })
        };
      });
      setOrders(temp.filter(v => v.type == 2));
    });
  };
  // useEffect(() => {
  //   transactionList({ customer_id: customerData.id }).then(data => {
  //     let resTran = data.transactions.map(t => {
  //       let date;
  //       if ("" + t.mtm !== "") {
  //         date = new DateObject({
  //           date: +t.mtm * 1000,
  //           calendar: persian,
  //           locale: persian_fa
  //         });
  //       }

  //       const isReceiver = +t.customer_id === +t.to_account.customer_id;

  //       return {
  //         id: t.bank_transaction__id,
  //         uid: t.customer_id,
  //         payDate: date ? date.format("YYYY/MM/DD") : "",
  //         payTime: date ? date.format("HH:mm") : "",
  //         payType: +t.type,
  //         bankName: isReceiver ? t.to_account.bank : t.from_account.bank,
  //         accountNumber: isReceiver
  //           ? t.to_account.account_number
  //           : t.from_account.account_number,
  //         status: +t.status
  //       };
  //     });
  //     setTransact(resTran);

  //     return resTran;
  //   });
  // }, []);
  // useEffect(() => {
  // orderList({ customer_id: customerData.id }).then(data => {
  //   let temp = [];
  //   temp = data.orders.map(value => {
  //     return {
  //       ...value,
  //       order_items: value.order_items.map(val => {
  //         return {
  //           ...val,
  //           OptionOrderItem: JSON.parse(val.OptionOrderItem)
  //         };
  //       })
  //     };
  //   });
  //   setOrders(temp.filter(v => v.type == 2));
  // });
  // }, [updater]);

  useEffect(() => {
    setCustomer(customerData);
    setTab([
      {
        id: "navs-pills-left-info",
        component: (
          <InfoTab
            customerData={customerData}
            bankName={bankName}
            setCustomerUpdater={setCustomerUpdater}
          />
        )
      },
      {
        id: "navs-pills-left-connection",
        component: <Message user_id={customerData.id} />
      },
      {
        id: "navs-pills-left-factors",
        component:
          orders.length > 0 ? (
            <OrderList orderDataList={orders} setUpdate={setUpdater} />
          ) : (
            <div>هیچ سفارشی برای این کاربر وجود ندارد</div>
          )
      },
      {
        id: "navs-pills-left-financial",
        component:
          transact.length > 0 ? (
            <TransactionList transactions={transact} />
          ) : (
            <div>هیچ تراکنشی وجود ندارد.</div>
          )
      }
    ]);
  }, [customerData, transact]);

  return (
    <>
      <CustomTooltip
        color="red_custom"
        placement="top"
        title="نمایش اطلاعات مشتری"
      >
        <div>
          <CustomButton
            className="shadow-none"
            onClick={() => {
              setCustomerInfoShow(true);
              getData();
            }}
          >
            <EyeIcon color="white" />
          </CustomButton>
        </div>
      </CustomTooltip>
      <Modal
        show={customerInfoShow}
        onHide={() => {
          setCustomerInfoShow(false);
        }}
      >
        <Modal.Header closeButton>
          کارتکست{" "}
          {customer.corporate == 1
            ? customer.company_name
            : `${customer.firstname} ${customer.lastname}`}
        </Modal.Header>
        <Modal.Body>
          <Tabs navItem={nav} tabContent={tab} type="horiz"></Tabs>
        </Modal.Body>
      </Modal>
    </>
  );
}
